import React, { useEffect, useContext, createContext, useState } from 'react'
import clsx from 'clsx'
import { createTheme, ThemeProvider, Theme } from "@mui/material/styles";
import { makeStyles } from '@mui/styles'
import CssBaseline from '@mui/material/CssBaseline';
import { BooleanParam, useQueryParam, JsonParam, withDefault } from 'use-query-params'
import TopBar from '../../components/top_bar'
import { SocketTable } from '../../components/socket_table'
import { socket, SocketContext } from '../../contexts/socket'
import { LatencyIndicator } from '../../components/latency_indicator';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { get_userinfo, get_schedule, get_schedule_by_user, UserInfo, ScheduleByUserEntry, ScheduleEntry, get_testSemids } from '../../api'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import SemidDisplay from '../../components/semid_display';
import { ReportRequester } from '../../components/report_requester'

import apiClient from '../../utils/http-common';
import Home from '../Home/home';
import { TextField, Button, Container, Box, Grid, Paper, Link, AppBar, Toolbar, Typography, Tooltip, FormControl, FormControlLabel, Avatar, Input, InputLabel } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import Banner from '../../components/banner';
import { getCurrentUser } from '../../services/auth-service';
import { useAuth } from '../../contexts/AuthContext';
import { MAX_WIDTH } from '../../App'
import { Redirect, useHistory } from 'react-router-dom';

import ReactGA from 'react-ga4';

export interface HeaderTable {
  title: string,
  user: string,
  semids: string,
  instrument: string,
  sa: string,
  oa: string,
  data_directories: string,
  date: string
}
//@ts-ignore
dayjs.extend(utc)

const IS_PRODUCTION: boolean = process.env.REACT_APP_ENVIRONMENT === 'production'
const barHeight = '60px';
const drawerWidth = '400px';
export const useStyles = makeStyles((theme: unknown) => ({
  root: {
    display: "flex",
    position: 'relative',
    height: '1000px'
  },
  toolbar: {
    paddingRight: '12px',
    paddingLeft: '20px'
  },
  toolbarIcon: {
    display: "flex",
    // alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
  },
  appBar: {
    position: 'fixed',
    height: barHeight,
    width: '100%',
  },
  leftDrawer: {
    overflow: 'auto',
    width: drawerWidth,
  },
  drawerPaper: {
    marginTop: barHeight,
    position: 'absolute',
    width: drawerWidth,
  },
  menuButton: {
    marginRight: '16px'
  },
  title: {
    marginLeft: '8px',
    flexGrow: 1,
  },
  content: {
    flexGrow: 1,
    marginTop: barHeight,
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: MAX_WIDTH,
    paddingBottom: '6em',
  },
  contentShift: {
    marginTop: barHeight,
    marginLeft: 0
  },
  container: {
    paddingTop: '36px',
    paddingBottom: '16px'
  },
  fixedHeight: { height: 240 },
  form: {
    margin: '0px',
    padding: '0px'
  }
}));

declare module '@mui/material/styles' {
  interface Components {
    [key: string]: any
  }
}
const handleTheme = (darkState: boolean | null | undefined): Theme => {
  const theme = createTheme({

    components: {
      // MuiTableCell: {
      //   styleOverrides: {
      //     //@ts-ignore
      //     root: {
      //       border: [[2, 'solid', '#666666']]
      //     }
      //   }
      // },
      MUIDataTableBodyRow: {
        root: {
          '&:nth-child(odd)': {
            backgroundColor: '#FF0000'
          },

        }
      },
      MUIDataTableCell: {
        styleOverrides: {
          root: {
            padding: '0px',
            borderBottom: [2, 'solid', '#666666'],
            // backgroundColor: '#CDCAC6',
          }
        }
      },
      MUIDataTableBodyCell: {
        styleOverrides: {
          root: {
            // borderRight: [[2, 'solid', '#666666']]
          },
        },
      },
    },
    palette: {
      mode: darkState ? 'dark' : 'light',
    }
  })
  return theme
}

export interface DownloadFilenames {
  ofname: boolean,
  koaid: boolean
}

export interface Levels {
  lev0: boolean,
  lev1: boolean,
  lev2: boolean,
}

export interface InstUserSem {
  userid?: string | null,
  setUserid: Function,
  semid?: string | null
  setSemid?: Function,
  imgSrc?: string
  setImgSrc: Function,
  levels: Levels,
  setLevels: Function,
  instruments: string[],
  downloadFilenames: boolean,
  setDownloadFilenames: Function
}

const initISU: InstUserSem = {
  userid: '',
  setUserid: () => { },
  semid: '',
  setSemid: () => { },
  imgSrc: '',
  setImgSrc: () => { },
  levels: { lev0: true, lev1: true, lev2: true },
  setLevels: () => { },
  instruments: [],
  downloadFilenames: false,
  setDownloadFilenames: () => { }
}

const ISUContext = createContext<InstUserSem>(initISU as InstUserSem)
export const useISUContext = () => useContext(ISUContext)


function Gui() {
  const classes = useStyles();
  const [darkState, setDarkState] = useQueryParam('darkState', withDefault(BooleanParam, true));
  const [toggleDrawer, setToggle] = useQueryParam('sidebarToggle', withDefault(BooleanParam, false));
  const [levels, setLevels] = useQueryParam('setLevels', withDefault(JsonParam, {
    lev0: false, lev1: false, lev2: false
  }));
  const theme = handleTheme(darkState)
  const [userid, setUserid] = useState<string | undefined>('');
  const [headerTable, setHeaderTable] = useState({} as HeaderTable)
  const [username, setUsername] = useState('');
  const [semid, setSemid] = useState('');
  const [imgSrc, setImgSrc] = useState(undefined);
  const [availableSemids, setAvailableSemids] = useState([] as string[])
  const [instruments, setInstruments] = useState([] as string[])

  const history = useHistory();

  const { user, token, watchDate, loading, setLoading, loggedIn } = useAuth();

  ReactGA.send({hitType: 'pageview', page: `/rti-gui/${window.location.search}`, title: 'ODAP - GUI'});

  useEffect(() => {
    const set_header_table = (name: string, semids: string[], date: string, insts: string[]) => {
      let instStr = ""
      for (let idx = 0; idx < insts.length; idx++) {
        instStr += `${insts[idx]}, `
      }
      instStr = instStr.slice(0, -2)
      let semidStr = ""
      for (let idx = 0; idx < semids.length; idx++) {
        semidStr += `${semids[idx]}, `
      }
      semidStr = semidStr.slice(0, -2)
      let table: HeaderTable = {
        title: "TableReport",
        user: name,
        semids: semidStr,
        instrument: instStr,
        sa: "TBD",
        oa: "TBD",
        data_directories: "TBD",
        date: date,
      }

      setHeaderTable(table)
    }

    // Api to update session data.
    const get_semid_list_api = () => {

      const name = `${user?.first} ${user?.last}`;
      setUsername(name)
      setUserid(user?.userid)
      const date = watchDate //remember to use ut date
      let semids_: string[] = []
      let instruments_: string[] = []

      // Api returns semid in pairs with matching instrument
      // Separate these pairs into instruments and semids for flexibility across frontend.
      user?.semidpairs?.forEach((x, y) => {
        const each_entry = x.split(":");
        const each_semid = each_entry[1]
        const each_instr = each_entry[0]
  
        semids_.push(each_semid);
        instruments_.push(each_instr)

        const roomid_semidpair = `${each_instr}_${each_semid}`;
        socket.emit('join_semid_room', { 'roomid_semidpair': roomid_semidpair, 'token': token }) //create room to receive rows 
      })
      
      // Setting Instruments based on SemidPairs received from Token
      // const insts = instruments_;
      setInstruments(instruments_)
      
      // Setting Semids based on SemidPairs received from Token
      // const semids = semids_;
      setAvailableSemids(semids_)
  
      socket.emit('request_metadata', semids_, {token:token, utdate: watchDate } )

      set_header_table(name, semids_, date, instruments_)

    }

    if (token) {
      get_semid_list_api()
    }

    // using single call for production and dev, may change this later.
    // if (IS_PRODUCTION) get_semid_list()
    // else mock_get_semid_list()

    return () => {
      // UnMounting
    }
  }, [token])

  const handleThemeChange = () => {
    setDarkState(!darkState)
  }

  const [downloadFilenames, setDownloadFilenames] = useState(false);

  const isu: InstUserSem = {
    userid: user?.userid,
    setUserid: setUserid,
    semid: semid,
    setSemid: setSemid,
    imgSrc: imgSrc,
    setImgSrc: setImgSrc,
    levels: levels,
    setLevels: setLevels,
    instruments: instruments,
    setDownloadFilenames: setDownloadFilenames,
    downloadFilenames: downloadFilenames 
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />  {/* CssBaseline lets ThemeProvider overwrite default css */}
      <ISUContext.Provider value={isu} >
        <main className={classes.root}>
          <TopBar
            username={username}
            darkState={darkState}
            handleThemeChange={handleThemeChange} />
          <Container sx={{ maxWidth: MAX_WIDTH }} maxWidth={false}>
            <div className={clsx(classes.content, {
              [classes.contentShift]: toggleDrawer,
            })}
            >
              <SocketContext.Provider value={socket}>
                <SemidDisplay availableSemids={availableSemids} levels={levels} />
                <SocketTable />
              </SocketContext.Provider>
            </div>
          </Container>
        </main>
      </ISUContext.Provider>
    </ThemeProvider>
  )
}

export default Gui;

